// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBfC-o9zuZpJqSFglMUeImNHMnANr6XcN0",
  authDomain: "minglemunch-36928.firebaseapp.com",
  projectId: "minglemunch-36928",
  storageBucket: "minglemunch-36928.appspot.com",
  messagingSenderId: "249509488470",
  appId: "1:249509488470:web:e8ba5fb1b6f6762a2a18f7",
  measurementId: "G-KFRCK8Y6EF",
};

export function initFirebase() {
  initializeApp(firebaseConfig);
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// const analytics = getAnalytics(app);
